import React, { Component } from 'react';
import ComboSave from './ComboSave';
import ComboList from './ComboList';
import { connect } from 'react-redux';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';

class ComboPage extends Component {
    constructor(props, context) {
        const comboId = props.params.id;
        super(props, context);
        this.state = {
            status: comboId ? "EDIT" : "LIST"
        };
    }

    componentWillMount() {

    }


    redirectToAddPage() {
        this.props.navigate("/manage/combo/add");
    }

    redirectToListPage() {
        this.props.navigate("/manage/combo");
    }

    render() {
        const comboId = this.props.params.id;
        const isSave = comboId || this.props.location.pathname === "/manage/combo/add";
        return (
            <React.Fragment>
                {
                    isSave ?
                        (<ComboSave
                            name="comboSave"
                            params={this.props.params} />)
                        : (<ComboList />)
                }
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (message) => dispatch(showError(message))
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ComboPage));